class ABZBenefitsMarquee extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {

    const infoContainer = this.closest('product-rerender');
    const track = this.querySelector('.abz-benefits-marquee__track');
    if (!track) return;

    // Clone the content to ensure seamless scrolling
    // We create a duplicate set of items and append them to the track
    // The CSS will handle the translation of the track from 0 to -50%
    const content = track.innerHTML;
    track.innerHTML = content + content + content;
  }
}

customElements.define('abz-benefits-marquee', ABZBenefitsMarquee);

function setActiveBenefitsMarquee() {
    document.querySelectorAll('product-rerender').forEach((infoContainer) => {
        const selectedCaseTypeInput = infoContainer.querySelector('.variant-picker__option[data-option-name="Cover Type"] input:checked');
        const selectedCaseType = selectedCaseTypeInput ? selectedCaseTypeInput.dataset.optionValue : null;
        let activeMarqueeFound = false;
        const allMarquees = infoContainer.querySelectorAll('abz-benefits-marquee');
        
        allMarquees.forEach((marquee) => {
            if (marquee.dataset.caseType == selectedCaseType) {
              marquee.classList.add('active');
              activeMarqueeFound = true;
            } else {
              marquee.classList.remove('active');
            }
        }); 

        if (!activeMarqueeFound) {
          allMarquees.forEach((marquee) => {
           (marquee.dataset.caseType == 'default') ? marquee.classList.add('active') : marquee.classList.remove('active');
          });
        }
    });
}

setActiveBenefitsMarquee();

document.addEventListener('variant:change', setActiveBenefitsMarquee);
document.addEventListener('variant:rerender', setActiveBenefitsMarquee);

class TabbedDetails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
      this.init();
  }

  init() {
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');

    this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            this.activateTab(tab);
        });
    });

    if (this.tabs.length > 0) {
        this.activateTab(this.tabs[0]);
    }
  }

  activateTab(selectedTab) {
    this.tabs.forEach(tab => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected);
        if (isSelected) {
            tab.classList.add('active');
        } else {
            tab.classList.remove('active');
        }
    });

    const targetId = selectedTab.getAttribute('aria-controls');
    this.panels.forEach(panel => {
        if (panel.id === targetId) {
            panel.removeAttribute('hidden');
        } else {
            panel.setAttribute('hidden', '');
        }
    });
  }
}

customElements.define('tabbed-details', TabbedDetails);